import React from 'react'
import styles from './styles.module.scss'

export default function ServerErrors({ errors, title }) {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{title}</h1>
      {Array.isArray(errors) ? (
        <ul className={styles.errorContainer}>
          {errors.map((e) => (
            <li className={styles.error}>{e}</li>
          ))}
        </ul>
      ) : (
        <div className={styles.error}>{errors}</div>
      )}
    </div>
  )
}
